const RELOAD_KEY = 'residesk:asset-reload'
const LOAD_ERROR =
  /^(Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS for )/i

export function installStaleAssetRecovery() {
  let refreshing = false
  window.addEventListener('vite:preloadError', (event) => {
    if (!LOAD_ERROR.test(event.payload?.message || '')) return
    if (refreshing) {
      event.preventDefault()
      return
    }
    try {
      const now = Date.now()
      // Survive the refresh; allow recovery again on a later deployment.
      if (now - Number(sessionStorage.getItem(RELOAD_KEY)) < 60_000) return
      sessionStorage.setItem(RELOAD_KEY, String(now))
    } catch {
      // Without a persistent guard, keep the error instead of risking a loop.
      return
    }
    refreshing = true
    event.preventDefault()
    window.location.reload()
  })
}
